import { useMemo } from 'react';

import { Phone } from 'lucide-react';

import BookACallButton from './BookACallButton';

export interface BookACallProps {
  application?: boolean;
}

const BookACall: React.FunctionComponent<BookACallProps> = function ({
  application = false,
}) {
  const title = useMemo(
    () =>
      [' Need help with your', application ? 'application?' : 'payment?'].join(
        ' ',
      ),
    [application],
  );
  return (
    <div className="grid grid-cols-[min-content_auto] gap-x-4 gap-y-4 md:gap-y-6 p-4 md:p-5 xl:p-6 border border-neutral-300 rounded-xl bg-neutral-000 md:shadow-lg">
      <div className="w-10 h-10 min-w-10 min-h-10 bg-purple-50 flex rounded-full">
        <Phone className="m-auto stroke-purple-300" size={20} />
      </div>
      <div className="flex flex-col w-full">
        <h2 className="text-16-24-b text-neutral-900 mb-1">{title}</h2>
        <h3 className="text-12-18 md:text-14-22 text-neutral-700">
          Give us a call and we&apos;ll guide you through the process step by
          step.
        </h3>
      </div>
      <div className="col-span-2">
        <BookACallButton />
      </div>
    </div>
  );
};

export default BookACall;
